!(function (o, t, i, s, d, e) {
    (d.ProductPage = function (t) {
        function s() {
            if (null === this.product) return console.warn("Product required to initialize page"), !1;
            var t = {
                    arrows: !i.touchevents,
                    fade: !i.touchevents,
                    draggable: !1,
                    prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
                    nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>',
                },
                s = o.extend({}, t),
                d = o.extend({}, t);
            return (
                (s.dots = !0),
                this.$productSlideShow.on("init", this._onSlideShowReady.bind(this)),
                this.$productSlideShow.on("afterChange", this._onSlideShowAfterChange.bind(this)),
                this.$productZoomModal.on("show.bs.modal", this._onZoomModalShow.bind(this)),
                this.$productZoomModal.on("shown.bs.modal", this._onZoomModalShown.bind(this)),
                this.$productZoomModal.length &&
                    ((s.asNavFor = ".product-zoom-slideshow"),
                    (d.asNavFor = ".product-slideshow"),
                    (d.lazyLoad = "ondemand"),
                    this.$zoomTrigger.on(
                        "click",
                        function () {
                            return this.$productZoomModal.modal("show"), !1;
                        }.bind(this)
                    )),
                this.$productZoomSlideshow.slick(d),
                this.$productSlideShow.slick(s),
                this
            );
        }
        var d = this,
            e = (o(window), { product: null, moneyFormat: "$ {{amount}}", msg: { addToCart: "Add To Cart", soldOut: "Sold out", unavailable: "Unavailable" } }),
            r = o.extend({}, e, t);
        return (
            (this.$productSlideShow = o(".product-slideshow")),
            (this.$productZoomModal = o("#product-zoom-modal")),
            (this.$productZoomSlideshow = o(".product-zoom-slideshow")),
            (this.$zoomTrigger = o(".product-media__zoom-trigger")),
            (this.$productThumbContainer = o(".product-thumbs")),
            (this.$productThumbs = o(".product-thumbs__thumb")),
            (this.$addToCartBtn = o("#add-to-cart")),
            (this.$productPrice = o(".product-price")),
            (this.product = r.product),
            (this.moneyFormat = r.moneyFormat),
            (this.msg = r.msg),
            (this._onZoomModalShow = function () {
                this.$productZoomModal.length && (this.$productZoomSlideshow.addClass("is-hidden"), this.$productZoomSlideshow.get(0).slick.refresh());
            }),
            (this._onZoomModalShown = function () {
                this.$productZoomModal.length && (this.$productZoomSlideshow.get(0).slick.refresh(), this.$productZoomSlideshow.removeClass("is-hidden"), this.$productZoomSlideshow.find(".slick-slide").first().focus());
            }),
            (this._onThumbClick = function (o) {
                var t = o.index();
                t !== this.$productSlideShow.slick("slickCurrentSlide") && (this.$productSlideShow.slick("slickGoTo", t), this.$productThumbs.removeClass("active"), o.addClass("active"));
            }),
            (this._onSlideShowAfterChange = function (o, t, i) {
                this.$productThumbs.removeClass("active"), this.$productThumbs.eq(i).addClass("active");
            }),
            (this._onSlideShowReady = function (t, i) {
                this.$productThumbs.length &&
                    (this.$productThumbs.eq(i.currentSlide).addClass("active"),
                    this.$productThumbs.on("click", function (t) {
                        return d._onThumbClick(o(this)), !1;
                    }));
            }),
            (this.updateFinancingMsg = async function (variant) {
              const price = variant ? variant.price : this.product.variants[0].price;
      
              console.log("Affirm?", window.affirm, window.affirm?.ui?.ready);
      
              const $msg = document.querySelector(".pdp-financing-msg");
      
              // if not ready, sleep and re-run
              if (!window.affirm?.ui?.payments?.get_estimate) {
                setTimeout(() => {
                  this.updateFinancingMsg(variant);
                }, 500);
                return;
              }
      
              console.log("financing msg:", $msg);
      
              if (!$msg) return;
      
              const financing = await affirm.ui.payments
                .get_estimate({ amount: price, apr: 0.15, months: 36 }, price)
                .catch((err) => null);
      
              console.log("financing:", financing);
      
              if (!financing) {
                $msg.style.display = "none";
                return; // hide element.
              }
      
              const $amount = $msg.querySelector("[data-financing-amount]");
              const { months, payment } = financing;
      
              $amount.textContent = window.Shopify.formatMoney(payment) + "/month";
      
              console.log(
                "Update financing message:",
                { months, payment },
                variant,
                s.formatMoney,
                this
              );
            }),
            (this.stripCents = function (o) {
                return o.replace(/\.00/, "");
            }),
            s.call(this)
        );
    }),
        (d.ProductPage.prototype = {
            update: function (o, t) {
              this.updateFinancingMsg(o);
              
                if (window.Shopify.isGiftCard) {
                    window.Shopify.giftCardCallback();
                }
                if(window.pdpMetafieldImagesByVariant) {
                    window.pdpMetafieldImagesByVariant(o, t);
                }
                var variantMetafields = this.product.variant_metafield || [];
                var hasPreOrder = variantMetafields.find((v) => v.id === o.id && v.preorder);
              
                hasPreOrder ? this.$addToCartBtn.parent().addClass('special-order-btn') : this.$addToCartBtn.parent().removeClass('special-order-btn');

                o
                    ? (o.available ? this.$addToCartBtn.removeClass("disabled").prop("disabled", !1).html(hasPreOrder? 'SPECIAL ORDER' : this.msg.addToCart) : this.$addToCartBtn.html(this.msg.soldOut).addClass("disabled").prop("disabled", !0),
                      o.compare_at_price > o.price,
                      this.$productPrice.html((this.product.tags.includes('price upon request')) ? `starting from ${this.stripCents(s.formatMoney(o.price, this.moneyFormat))}` : this.stripCents(s.formatMoney(o.price * 1, this.moneyFormat))))
                    : (this.$productPrice.empty(), this.$addToCartBtn.html(this.msg.unavailable).addClass("disabled").prop("disabled", !0));
            },
        });
})(jQuery, _, Modernizr, Shopify, window.JM || {});
